import { render, staticRenderFns } from "./TextIconCard.vue?vue&type=template&id=55882de8"
import script from "./TextIconCard.vue?vue&type=script&lang=js"
export * from "./TextIconCard.vue?vue&type=script&lang=js"
import style0 from "./TextIconCard.vue?vue&type=style&index=0&id=55882de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports